{
  "equipmentMasterTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Equipment Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "description",
        "displayName": "Description",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "300px"
        }
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "50px"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Equipment by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "equipment_name"
      }
    ]
  }
}
